class StickyHeader extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.header = document.getElementById("shopify-section-header");
        this.headerBounds = {};
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.mainMenu = this.querySelector(".menu-left");
        this.mainMenuLinks = document.querySelectorAll(".mainMenu > a");
        this.submenus = document.querySelectorAll(".submenu");
        this.cartButton = document.querySelector("#cart-item-count");
        this.mobileCartButton = document.querySelector(".mobileMenu .left");
        this.mobileMenuOpener = document.querySelector(".mobileMenuOpener");

        this.onScrollHandler = this.onScroll.bind(this);
        this.onShowSubmenuHandler = this.showSubmenu.bind(this);
        this.onHideSubmenusHandler = this.hideSubmenus.bind(this);
        this.onMobileMenuHandler = this.onMobileMenu.bind(this);

        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
        window.addEventListener("scroll", this.onScrollHandler, false);

        this.mainMenu.addEventListener(
            "mouseleave",
            this.onHideSubmenusHandler
        );
        this.mobileMenuOpener.addEventListener(
            "click",
            this.onMobileMenuHandler
        );

        let scope = this;

        if (isTouchDevice()) {
            this.mainMenuLinks.forEach((link) => {
                link.addEventListener("click", scope.onShowSubmenuHandler);
            });
        } else {
            this.mainMenuLinks.forEach((link) => {
                link.addEventListener("mouseenter", scope.onShowSubmenuHandler);
            });
        }

        this.createObserver();
    }

    disconnectedCallback() {
        this.removeEventListener(
            "preventHeaderReveal",
            this.hideHeaderOnScrollUp
        );
        window.removeEventListener("scroll", this.onScrollHandler);

        let scope = this;
        if (isTouchDevice()) {
            this.mainMenuLinks.forEach((link) => {
                link.removeEventListener("click", scope.onShowSubmenuHandler);
            });
        } else {
            this.mainMenuLinks.forEach((link) => {
                link.removeEventListener(
                    "mouseenter",
                    scope.onShowSubmenuHandler
                );
            });
        }

        this.mainMenu.removeEventListener(
            "mouseleave",
            this.onHideSubmenusHandler
        );
        this.mobileMenuOpener.removeEventListener(
            "click",
            this.onMobileMenuHandler
        );
    }

    createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
    }

    onScroll() {
        const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;

        if (
            scrollTop > this.currentScrollTop &&
            scrollTop > this.headerBounds.bottom
        ) {
            requestAnimationFrame(this.hide.bind(this));
        } else if (
            scrollTop < this.currentScrollTop &&
            scrollTop > this.headerBounds.bottom
        ) {
            if (!this.preventReveal) {
                requestAnimationFrame(this.reveal.bind(this));
            } else {
                window.clearTimeout(this.isScrolling);

                this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                }, 66);

                requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
    }

    hide() {
        document.body.classList.add(
            "shopify-section-header-hidden",
            "shopify-section-header-sticky"
        );
        this.closeMenuDisclosure();
    }

    reveal() {
        document.body.classList.add("shopify-section-header-sticky", "animate");
        document.body.classList.remove("shopify-section-header-hidden");
    }

    reset() {
        document.body.classList.remove(
            "shopify-section-header-hidden",
            "shopify-section-header-sticky",
            "animate"
        );
    }

    closeMenuDisclosure() {
        this.disclosures =
            this.disclosures || this.header.querySelectorAll("header-menu");
        this.disclosures.forEach((disclosure) => disclosure.close());
    }

    showSubmenu(e) {
        e.preventDefault();
        e.stopPropagation();

        this.hideSubmenus();

        this.mainMenuLinks.forEach((link) => {
            link.classList.add("unselected");
            link.classList.remove("current");
        });

        let link = e.currentTarget || e.target;
        let name = link.innerHTML.toLowerCase().trim();
        link.classList.remove("unselected");
        link.classList.add("current");

        if (name == "kids") {
            this.classList.add("kids");
        } else if (name == "impact") {
            this.classList.add("impact");
        } else if (name == "community") {
            this.classList.add("community");
        }

        let currents = document.querySelectorAll(".submenu." + name);

        if (currents.length) {
            currents.forEach((current) => {
                current.classList.add("show");
                this.style.height = parseInt(50 + current.offsetHeight) + "px";
            });
        } else {
            if (isTouchDevice()) {
                window.location = link.href;
            }
        }

        document.body.classList.add("menu-opened");

        switch (name) {
            case "woman":
            case "femme":
            case "mujer":
                selectMobileWoman();
                break;
            case "man":
            case "homme":
            case "hombre":
                selectMobileMan();
                break;
            case "kids":
                this.classList.add("kids");
                selectMobileKids();
                break;
            case "impact":
            case "impacto":
                this.classList.add("impact");
                selectMobileImpact();
                break;
            case "community":
            case "comunidad":
                this.classList.add("community");
                selectMobileCommunity();
                break;
        }

        if (isTouchDevice()) {
            return false;
        }
    }

    hideSubmenus() {
        this.mainMenuLinks.forEach((link) => {
            link.classList.remove("unselected");
        });

        this.submenus.forEach((submenu) => {
            submenu.classList.remove("show");
        });

        document.body.classList.remove("menu-opened");
        this.classList.remove("kids");
        this.classList.remove("impact");
        this.classList.remove("community");

        this.style.height = "56px";

        // Mobile
        let columns = document.querySelectorAll(".submenu .column");
        columns.forEach((column) => {
            column.classList.remove("current");
        });
    }

    onMobileMenu() {
        document.body.classList.toggle("menu-opened");
    }
}

customElements.define("sticky-header", StickyHeader);

function setupMobileCurrentMenu() {
    if (window.innerWidth <= 960) {
        let bodyClassList = document.body.getAttribute("class");

        if (
            bodyClassList.indexOf("woman") != -1 ||
            bodyClassList.indexOf("femme") != -1 ||
            bodyClassList.indexOf("mujer") != -1
        ) {
            selectMobileWoman();
            return;
        }

        if (
            bodyClassList.indexOf("man") != -1 ||
            bodyClassList.indexOf("homme") != -1 ||
            bodyClassList.indexOf("hombre") != -1
        ) {
            selectMobileMan();
            return;
        }

        if (bodyClassList.indexOf("kids") != -1) {
            selectMobileThinkito();
            return;
        }

        if (
            bodyClassList.indexOf("impact") != -1 ||
            bodyClassList.indexOf("impacto") != -1
        ) {
            selectMobileImpact();
            return;
        }

        if (
            bodyClassList.indexOf("community") != -1 ||
            bodyClassList.indexOf("comunidad") != -1
        ) {
            selectMobileCommunity();
            return;
        }

        selectMobileWoman();
    }
}

function selectMobileWoman() {
    document.querySelector(".mainMenu a:nth-child(1)").classList.add("current");
    document.querySelector(".submenu.woman").classList.add("show");
}

function selectMobileMan() {
    document.querySelector(".mainMenu a:nth-child(2)").classList.add("current");
    document.querySelector(".submenu.man").classList.add("show");
}

function selectMobileKids() {
    document.querySelector(".mainMenu a:nth-child(3)").classList.add("current");
    document.querySelector(".submenu.kids").classList.add("show");
}

function selectMobileImpact() {
    document.querySelector(".mainMenu a:nth-child(4)").classList.add("current");
    document.querySelector(".submenu.impact").classList.add("show");
}

function selectMobileCommunity() {
    document.querySelector(".mainMenu a:nth-child(5)").classList.add("current");
    document.querySelector(".submenu.community").classList.add("show");
}

setupMobileCurrentMenu();
